import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import WhatsAppFloat from "@/components/campus/WhatsAppFloat";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Colleges from "@/pages/Colleges";
import CollegeDetail from "@/pages/CollegeDetail";
import StudentDashboard from "@/pages/StudentDashboard";
import AmbassadorDashboard from "@/pages/AmbassadorDashboard";
import Chat from "@/pages/Chat";
import Call from "@/pages/Call";
import Book from "@/pages/Book";
import Decided from "@/pages/Decided";
import Leaderboard from "@/pages/Leaderboard";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import "@/App.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" toastOptions={{style:{background:"#1E293B",color:"#fff",border:"1px solid rgba(255,255,255,0.1)"}}}/>
        <Routes>
          <Route path="/" element={<Landing/>}/>
          <Route path="/auth" element={<Auth/>}/>
          <Route path="/colleges" element={<Colleges/>}/>
          <Route path="/college/:slug" element={<CollegeDetail/>}/>
          <Route path="/dashboard/student" element={<StudentDashboard/>}/>
          <Route path="/dashboard/ambassador" element={<AmbassadorDashboard/>}/>
          <Route path="/chat/:id" element={<Chat/>}/>
          <Route path="/call/:id" element={<Call/>}/>
          <Route path="/book" element={<Book/>}/>
          <Route path="/decided/:slug" element={<Decided/>}/>
          <Route path="/leaderboard" element={<Leaderboard/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/admin" element={<Admin/>}/>
        </Routes>
        <WhatsAppFloat/>
      </BrowserRouter>
    </AuthProvider>
  );
}
